import React from 'react'
import PropTypes from 'prop-types'
import { Card } from '@paypalcorp/pp-react'

import './shimmer-loader.less'

// component to load different shimmers with different sizes based on the props.
const ShimmerLoader = (props) => {
  const { customLoaderStyle, rows } = props

  const getShimmer = () => {
    const defaultShimmerStyle = {
      height: '10rem',
      width: '100%',
      marginBottom: '1rem',
    }
    const customStyle = { ...defaultShimmerStyle, ...customLoaderStyle }

    const shimmers = Array.from({ length: rows }, (_, i) => {
      return (
        <div key={`shimmer${i}`} style={customStyle}>
          <Card isLoading />
        </div>
      )
    })

    return <>{shimmers}</>
  }

  return getShimmer()
}

ShimmerLoader.propTypes = {
  customLoaderStyle: PropTypes.shape({}),
  rows: PropTypes.number,
}

ShimmerLoader.defaultProps = {
  rows: 1,
}
export default ShimmerLoader
